import Components from "slotworks/components/components";
import Translations from "slotworks/i18n/translations";
import State from "slotworks/state-machine/states/state";

export default class MaxFreespins extends State {
    public onEnter() {
        const contents = new Map<string, string>();
        contents.set("body", Translations.get("fs.max"));
        Components.prompt.show(["info"], contents).then(() => this.complete());
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/max-freespins.ts